<template>
  <div id="content">
    <div
      class="soglasje-sdd-eracun"
      :class="{
        'tw-mt-skip-header': !hideHeader,
        'desktop:tw-mt-skip-header-d': !hideHeader,
      }"
    >
      <ui-header v-if="!hideHeader" @back="onStepChange('BACK')"></ui-header>

      <ui-form
        :showStepper="false"
        :current="currentStep"
        id="content"
        class="tw-h-full tw-bg-tzz-green-light"
        @progress-next="onStepChange(currentStep + 1)"
      >
        <!--        STEP 0 - PREGLED OSEBNIH PODATKOV -->
        <ui-formgroup
          v-if="currentStep === 0"
          v-show="
            authData &&
            authData.soglasjeSDDEracun.requireInputClientData === true
          "
          :key="0"
          class="soglasje-sdd-eracun__pregled-os-pod tw-absolute tw-w-full"
        >
          <div
            class="content tw-w-full tw-mx-auto mini:tw-w-11/12 mob:tw-w-[343px]"
          >
            <h1
              class="soglasje-sdd-eracun__pregled-os-pod-title tw-pt-mid tw-mb-big tw-text-tzz-dark-gray tw-font-bold tw-text-title tw-leading-40 tablet:tw-text-center desktop:tw-pt-extra"
            >
              Pred nadaljevanjem preverite točnost izpisanih podatkov oz.
              obvezno izpolnite z zvezdico označena polja
            </h1>

            <ui-input
              label="Ime"
              name="clientFirstName"
              v-model="client.firstName"
              :required="true"
              @change="setClientFirstNameCapitalised()"
              class="!tw-mt-0 !tw-mb-small"
            ></ui-input>

            <ui-input
              label="Priimek"
              name="clientLastName"
              v-model="client.lastName"
              :required="true"
              class="!tw-mt-0 !tw-mb-small"
            ></ui-input>

            <ui-input
              label="Davčna številka"
              name="vat"
              v-model="client.vat"
              :required="true"
              :validate="davcnaValidate"
              :show-valid-indicator="true"
              :disabled="clientVATDisabled"
              class="!tw-mt-0 !tw-mb-small"
            ></ui-input>

            <div
              class="tw-flex tw-justify-between tw-flex-wrap !tw-m-0 !tw-mx-auto !tw-mb-small mini:tw-w-full mob:tw-w-[343px]"
            >
              <ui-input
                label="ZZZS številka"
                name="kzz"
                :maxlength="9"
                :minlength="9"
                v-model="client.kzz"
                :validate="kzzValidate"
                :disabled="clientKZZDisabled"
                :required="true"
                class="!tw-w-[calc(100%-34px)] !tw-m-0"
              ></ui-input>

              <stevilka-zdravstvene-kartice-info></stevilka-zdravstvene-kartice-info>
            </div>

            <ui-datepicker
              ref="birthDateDP"
              label="Datum rojstva"
              name="birthDate"
              :value="client.birthDate"
              @change="
                client.birthDate = $event;
                onBirthDateChanged($event);
              "
              :openDate="birthDateOpen"
              :required="true"
              :disabled="clientBirthDateDisabled"
              class="tw-w-full !tw-mt-0 !tw-mb-40 !tw-mx-auto"
            ></ui-datepicker>

            <ui-button
              class="soglasje-sdd-eracun__pregled-os-pod-next !tw-w-full !tw-my-0 !tw-mb-20 !tw-mx-0 !tw-text-normal"
              label="NADALJUJ"
              :type="'primary'"
              fg-progress-next
              fg-validate
            ></ui-button>

            <ui-button
              class="!tw-flex !tw-my-0 !tw-mx-auto !tw-mb-40 !tw-text-normal tw-w-full"
              label="NAZAJ"
              :type="'flat green'"
              @click="onStepChange('BACK')"
            ></ui-button>
          </div>
        </ui-formgroup>

        <!--        STEP 1 - IZBERITE NOV NACIN PLACILA -->
        <ui-formgroup
          v-if="currentStep === 1"
          :key="1"
          class="soglasje-sdd-eracun__nacin-placila tw-absolute tw-w-full"
        >
          <div class="content tw-mx-auto mini:tw-w-11/12 mob:tw-w-[343px]">
            <h1
              class="soglasje-sdd-eracun__pregled-izbira-kontakta-title tw-pt-mid tw-mb-big tw-text-tzz-dark-gray tw-font-bold tw-text-title tw-leading-40 tw-text-center desktop:tw-pt-extra"
            >
              Izberite nov način plačila
            </h1>

            <p
              class="tw-mb-mid tw-text-tzz-dark-gray tw-leading-[24px] tw-text-center tw-text-[15px]"
            >
              Izberite eno izmed možnosti.
            </p>

            <ui-button-with-icon
              label="SEPA direktna obremenitev"
              icon="bank-card"
              :show-next-icon="true"
              @click="onPaymentMethodSelected('L')"
            >
            </ui-button-with-icon>

            <ui-button-with-icon
              label="E-račun v spletno banko"
              icon="e-racun"
              :show-next-icon="true"
              @click="onPaymentMethodSelected('E')"
            >
            </ui-button-with-icon>

            <ui-button
              class="!tw-flex !tw-my-0 !tw-mx-auto !tw-mt-40 !tw-text-normal tw-w-full"
              label="NAZAJ"
              :type="'flat green'"
              @click="onStepChange('BACK')"
            ></ui-button>
          </div>
        </ui-formgroup>

        <!--        STEP 2 - DOLOCITE TRANSAKCIJSKI RACUN ZA PLACILO PREMIJE  -->
        <ui-formgroup
          v-if="currentStep === 2"
          :key="2"
          class="soglasje-sdd-eracun__trr tw-absolute tw-w-full"
        >
          <div class="content tw-mx-auto mini:tw-w-11/12 mob:tw-w-[343px]">
            <h1
              class="soglasje-sdd-eracun__trr tw-pt-mid tw-mb-mid tw-text-tzz-dark-gray tw-font-bold tw-text-title tw-leading-40 tw-text-center desktop:tw-pt-extra"
            >
              Določite transakcijski račun
            </h1>

            <div v-if="isClientIBANsAutofill || clientIBANsVerified.length > 0">
              <p
                class="tw-mb-mid tw-text-tzz-dark-gray tw-leading-[24px] tw-text-center tw-text-[15px]"
              >
                Izberite eno izmed možnosti.
              </p>

              <ui-selectable-trr
                v-for="(trr, i) of clientIBANsAutofill"
                :key="i"
                :trr-info="trr"
                :selected="inputTRR === trr.iban"
                @toggle="onSelectedTRRToggle($event)"
              >
              </ui-selectable-trr>

              <ui-selectable-trr
                v-for="(trr, i) of clientIBANsVerified"
                :key="
                  i + (isClientIBANsAutofill ? clientIBANsAutofill.length : 0)
                "
                :trr-info="trr"
                :selected="inputTRR === trr.iban"
                @toggle="onSelectedTRRToggle($event)"
              >
              </ui-selectable-trr>
            </div>

            <p
              v-else
              class="tw-mb-mid tw-text-tzz-dark-gray tw-leading-[24px] tw-text-center tw-text-[15px]"
            >
              Nimate še določenega transakcijskega računa.
            </p>

            <ui-divider v-if="isClientIBANsAutofill"></ui-divider>

            <ui-button
              label="VNESI ŠTEVILKO RAČUNA"
              @click="onEnterAlternativeTRRClicked()"
              type="white"
              icon-front="add"
              class="tw-w-full !tw-m-0 !tw-text-[12px] !tw-mb-mid !tw-mt-0"
            ></ui-button>

            <ui-button
              v-if="isClientIBANsAutofill"
              class="soglasje-sdd-eracun__trr-next !tw-w-full !tw-m-0 !tw-mb-20 !tw-text-normal"
              label="NADALJUJ"
              :type="'primary'"
              :disabled="!this.inputTRR"
              @click="onTRRSet()"
              fg-keydown-enter-click
            ></ui-button>

            <ui-button
              class="!tw-flex !tw-my-0 !tw-mx-auto !tw-mb-40 !tw-text-normal tw-w-full"
              label="NAZAJ"
              :type="'flat green'"
              @click="onStepChange('BACK')"
            ></ui-button>
          </div>
        </ui-formgroup>

        <!--        STEP 3 - VNESITE TRANSAKCIJSKI RACUN ZA PLACILO PREMIJE  -->
        <ui-formgroup
          v-if="currentStep === 3"
          :key="3"
          class="soglasje-sdd-eracun__rocni-trr tw-absolute tw-w-full"
          @validated="alternativeTRRFGValid = $event"
        >
          <div class="content tw-mx-auto mini:tw-w-11/12 mob:tw-w-[343px]">
            <h1
              class="soglasje-sdd-eracun__rocni-trr tw-pt-mid tw-mb-big tw-text-tzz-dark-gray tw-font-bold tw-text-title tw-leading-40 tw-text-center desktop:tw-pt-extra"
            >
              Vnesite številko transakcijskega računa
            </h1>

            <ui-input
              :label="'Številka transakcijskega računa'"
              v-model="inputTRR"
              name="iban"
              :validate="trrValidate"
              @validated="onTRRValidated($event)"
            ></ui-input>

            <ui-input
              label="Naziv banke"
              name="clientBankName"
              v-model="alternativeTRRBankName"
              :disabled="true"
              class="!tw-mt-0 !tw-mb-small"
            ></ui-input>

            <ui-input
              label="Imetnik transakcijskega računa"
              name="alternativeTRROwner"
              v-model="alternativeTRROwner"
              :required="true"
              :disabled="true"
              class="!tw-mt-0 !tw-mb-small"
            ></ui-input>

            <ui-checkbox
              :value="trrAgreement"
              name="trrAgreement"
              :required="true"
              title="Potrjujem, da sem imetnik/ca navedenega transakcijskega računa"
              @change="trrAgreement = $event"
              class="!tw-w-full"
            ></ui-checkbox>

            <ui-button
              class="soglasje-sdd-eracun__rocni-trr !tw-w-full !tw-my-20 !tw-mx-0 !tw-text-normal"
              label="NADALJUJ"
              :type="'primary'"
              :disabled="
                !(
                  alternativeTRRFGValid &&
                  inputTRR &&
                  alternativeTRRBankName &&
                  alternativeTRRBankBIC
                )
              "
              @click="onTRRSet"
              fg-keydown-enter-click
            ></ui-button>

            <ui-button
              class="!tw-flex !tw-my-0 !tw-mx-auto !tw-mb-40 !tw-text-normal tw-w-full"
              label="NAZAJ"
              :type="'flat green'"
              @click="onStepChange('BACK')"
            ></ui-button>
          </div>
        </ui-formgroup>

        <!--        STEP 4 - DOLOCITE MOBILNO TELEFONSKO STEVILKO ZA AKTIVACIJO  -->
        <ui-formgroup
          v-if="currentStep === 4"
          :key="4"
          class="soglasje-sdd-eracun__pregled-izbira-kontakta tw-absolute tw-w-full"
        >
          <!--        kontakt loader-->
          <div
            v-if="isContactsLoading"
            class="tw-h-[calc(100vh-50px)] tw-flex tw-justify-center tw-items-center"
          >
            <ui-mini-loader></ui-mini-loader>
          </div>

          <div
            v-if="!isContactsLoading && clientContacts"
            class="tw-mx-auto mini:tw-w-11/12 mob:tw-w-[343px]"
          >
            <h1
              class="soglasje-sdd-eracun__pregled-izbira-kontakta-title tw-pt-mid tw-mb-big tw-text-tzz-dark-gray tw-font-bold tw-text-title tw-leading-40 tw-text-center desktop:tw-pt-extra"
            >
              Določite mobilno telefonsko številko
            </h1>

            <p
              class="tw-mb-mid tw-text-tzz-dark-gray tw-leading-[24px] tw-text-center tw-text-[15px]"
            >
              Na izbrano telefonsko številko boste prejeli SMS sporočilo za
              aktivacijo spremembe načina plačila premije.
            </p>

            <!--            AUTOFILL PHONE-->
            <div v-if="isClientPhoneOptionsAutofill">
              <p
                class="tw-mb-mid tw-text-tzz-dark-gray tw-leading-[24px] tw-text-center tw-text-[15px] mini:tw-mb-mid mob:tw-mb-0"
              >
                Izberite mobilno telefonsko številko iz seznama:
              </p>

              <ui-select
                label="Mobilna telefonska številka"
                :value="clientContact"
                name="clientContactPhone"
                :options="phoneAutofillOptions"
                @change="onAutofillOptionSelected($event)"
              ></ui-select>

              <ui-divider></ui-divider>
            </div>

            <!--              PHONE ALTERNATIVE BUTTON-->
            <ui-button
              label="DODAJ MOBILNO TELEFONSKO ŠT."
              @click="onEnterAlternativeClientContactClicked()"
              type="white"
              icon-front="add"
              class="!tw-w-full !tw-mt-0 !tw-mb-mid !tw-mx-0"
            ></ui-button>

            <ui-button
              v-if="isClientPhoneOptionsAutofill"
              class="soglasje-sdd-eracun__pregled-izbira-kontakta-next !tw-w-full !tw-my-0 !tw-mb-20 !tw-mx-0 !tw-text-normal"
              label="NADALJUJ"
              :type="'primary'"
              :disabled="!allowAttemptPOBRContactVerification"
              @click="onAttemptPOBRContactVerification()"
              fg-keydown-enter-click
            ></ui-button>

            <ui-button
              class="!tw-flex !tw-my-0 !tw-mx-auto !tw-mb-40 !tw-text-normal tw-w-full"
              label="NAZAJ"
              :type="'flat green'"
              @click="onStepChange('BACK')"
            ></ui-button>
          </div>
        </ui-formgroup>

        <!--        STEP 5 - DODAJTE MOBILNO TELEFONSKO STEVILKO  -->
        <ui-formgroup
          v-if="currentStep === 5"
          :key="5"
          class="soglasje-sdd-eracun__alternativni-kontakti tw-absolute tw-w-full"
          @validated="alternativeContactFGValid = $event"
        >
          <div class="content tw-mx-auto mini:tw-w-11/12 mob:tw-w-[343px]">
            <h1
              class="soglasje-sdd-eracun__pregled-izbira-kontakta-title tw-pt-mid tw-mb-big tw-text-tzz-dark-gray tw-font-bold tw-text-title tw-leading-40 tw-text-center desktop:tw-pt-extra"
            >
              Dodajte mobilno telefonsko številko
            </h1>

            <ui-input
              label="Mobilna telefonska številka"
              :name="'clientPhone'"
              v-model="alternativeClientContactValue"
              :required="true"
              :validate="phoneValidate"
              @input="onAlternativeClientContactFieldInput()"
              class="!!tw-mx-0 !tw-mb-small"
            ></ui-input>

            <ui-button
              class="soglasje-sdd-eracun__pregled-izbira-kontakta-next !tw-w-full !tw-my-0 !tw-mx-auto !tw-mb-20 !tw-text-[14px]"
              label="POTRDI MOBILNO TEL. ŠTEVILKO"
              :type="'primary'"
              :disabled="!alternativeContactFGValid"
              @click="onAddClientContact()"
              fg-keydown-enter-click
            ></ui-button>

            <ui-button
              class="!tw-flex !tw-my-0 !tw-mx-auto !tw-mb-40 !tw-text-normal tw-w-full"
              label="NAZAJ"
              :type="'flat green'"
              @click="onStepChange('BACK')"
            ></ui-button>
          </div>
        </ui-formgroup>

        <!--        STEP 6 - POTRDITE MOBILNO TELEFONSKO STEVILKO  -->
        <ui-formgroup
          v-if="currentStep === 6"
          :key="6"
          class="tw-absolute tw-w-full"
        >
          <div class="content tw-mx-auto mini:tw-w-11/12 mob:tw-w-[343px]">
            <h1
              class="soglasje-sdd-eracun__pregled-izbira-kontakta-title tw-pt-mid tw-mb-big tw-text-tzz-dark-gray tw-font-bold tw-text-title tw-leading-40 tw-text-center desktop:tw-pt-extra"
            >
              Potrdite mobilno telefonsko številko
            </h1>

            <p
              class="potrditev-alternativnega-kontakta-text tw-mt-mid tw-mb-xs tw-text-center tw-text-normal tw-leading-22 tw-text-tzz-dark-gray desktop:tw-pt-extra"
            >
              Za potrditev mobilne telefonske številke
            </p>

            <p
              class="potrditev-alternativnega-kontakta-text tw-mb-xs tw-text-center tw-text-normal tw-leading-22 tw-font-bold tw-text-tzz-dark-gray"
            >
              {{ clientContact.maskedValue }}
            </p>
            <p
              class="potrditev-alternativnega-kontakta-text tw-mb-mid tw-text-center tw-text-normal tw-leading-22 tw-text-tzz-dark-gray"
            >
              vpišite kodo, ki ste jo prejeli v SMS sporočilu.
            </p>

            <p
              class="potrditev-alternativnega-kontakta-text tw-mt-0 tw-mb-small tw-text-center tw-text-normal tw-leading-22 tw-text-tzz-dark-gray"
            >
              Koda:
            </p>

            <ui-code-input
              ref="contact-code-input"
              :length="5"
              @validated="
                allowGSMContactOTPCheck = $event;
                otpCodeInput = undefined;
              "
              @valid="otpCodeInput = $event"
              class="tw-mb-40"
            >
            </ui-code-input>

            <ui-button
              class="soglasje-sdd-eracun__pregled-izbira-kontakta-check !tw-w-full !tw-m-0 !tw-mb-20 !tw-text-[14px]"
              label="PREVERI KODO"
              :type="'primary'"
              :disabled="!allowGSMContactOTPCheck"
              @click="onCheckGSMContactOTP()"
              fg-keydown-enter-click
            ></ui-button>

            <ui-button
              class="!tw-flex !tw-my-0 !tw-mx-auto !tw-mb-big !tw-text-normal tw-w-full"
              label="NAZAJ"
              :type="'flat green'"
              @click="onStepChange('BACK')"
            ></ui-button>

            <p
              class="potrditev-alternativnega-kontakta-text tw-mt-0 tw-mb-xs tw-text-center tw-text-normal tw-leading-22 tw-text-tzz-dark-gray"
            >
              Niste prejeli SMS sporočila?
            </p>

            <button
              class="tw-block tw-mx-auto tw-mb-mid tw-text-[15px] tw-font-bold tw-text-tzz-blue tw-outline-none"
              @click.prevent="onAddClientContact()"
            >
              Pošlji znova
            </button>

            <p
              class="potrditev-alternativnega-kontakta-text tw-mt-0 tw-mb-xs tw-text-center tw-text-normal tw-leading-22 tw-text-tzz-dark-gray"
            >
              V primeru težav pri potrjevanju mobilne telefonske številke nas
              pokličite na
              <button @click="onTZZCall" class="tw-font-bold tw-underline">
                080 26 64.
              </button>
            </p>
          </div>
        </ui-formgroup>

        <!--        STEP 7 - POVZETEK VLOGE  -->
        <ui-formgroup
          v-if="currentStep === 7"
          :key="7"
          class="tw-absolute tw-w-full"
        >
          <div
            class="content tw-mx-auto mini:tw-w-11/12 mob:tw-w-[343px] tablet-small:tw-w-[608px]"
          >
            <h1
              class="soglasje-sdd-eracun__recap tw-pt-mid tw-mb-mid tw-text-tzz-dark-gray tw-font-bold tw-text-title tw-leading-40 tw-text-center desktop:tw-pt-extra"
            >
              Povzetek vloge
            </h1>

            <div
              class="recap-section tw-p-small tw-mb-xs tw-rounded-10 tw-bg-white"
            >
              <h1
                class="tw-mb-small tw-font-sans tw-font-bold tw-text-20 tw-leading-[40px] tw-text-tzz-dark-gray tw-tracking-[5px]"
              >
                VLAGATELJ
              </h1>

              <div
                class="recap-section__entry tw-flex tw-justify-between tw-mb-small tw-gap-[5px] tw-font-sans tw-text-normal tw-leading-[30px] tw-tracking-title"
              >
                <p class="entry-field tw-m-0">Ime:</p>
                <p
                  class="entry-value tw-break-words tw-m-0 tw-font-bold tw-self-end"
                >
                  {{ client.firstName }}
                </p>
              </div>

              <div
                class="recap-section__entry tw-flex tw-justify-between tw-mb-small tw-gap-[5px] tw-font-sans tw-text-normal tw-leading-[30px] tw-tracking-title"
              >
                <p class="entry-field tw-m-0">Priimek:</p>
                <p
                  class="entry-value tw-break-words tw-m-0 tw-font-bold tw-self-end"
                >
                  {{ client.lastName }}
                </p>
              </div>

              <div
                class="recap-section__entry tw-flex tw-justify-between tw-mb-small tw-gap-[5px] tw-font-sans tw-text-normal tw-leading-[30px] tw-tracking-title"
              >
                <p class="entry-field tw-m-0">Davčna številka:</p>
                <p
                  class="entry-value tw-break-words tw-m-0 tw-font-bold tw-self-end"
                >
                  {{ client.vat }}
                </p>
              </div>

              <div
                v-if="client.kzz && (authData.m === 3 || authData.m === 9)"
                class="recap-section__entry tw-flex tw-justify-between tw-mb-small tw-gap-[5px] tw-font-sans tw-text-normal tw-leading-[30px] tw-tracking-title"
              >
                <p class="entry-field tw-m-0">ZZZS številka:</p>
                <p
                  class="entry-value tw-break-words tw-m-0 tw-font-bold tw-self-end"
                >
                  {{ client.kzz }}
                </p>
              </div>

              <div
                v-if="
                  client.birthDate && (authData.m === 4 || authData.m === 9)
                "
                class="recap-section__entry tw-flex tw-justify-between tw-mb-0 tw-gap-[5px] tw-font-sans tw-text-normal tw-leading-[30px] tw-tracking-title"
              >
                <p class="entry-field tw-m-0">Datum rojstva:</p>
                <p
                  class="entry-value tw-break-words tw-m-0 tw-font-bold tw-self-end"
                >
                  {{ displayValues.birthDate }}
                </p>
              </div>
            </div>

            <div
              class="recap-section tw-p-small tw-mb-xs tw-rounded-10 tw-bg-white"
            >
              <h1
                class="tw-mb-small tw-font-sans tw-font-bold tw-text-20 tw-leading-[40px] tw-text-tzz-dark-gray tw-tracking-[5px]"
              >
                SPREMEMBA NAČINA PLAČILA
              </h1>

              <div
                class="recap-section__entry tw-flex tw-justify-between tw-mb-small tw-gap-[5px] tw-font-sans tw-text-normal tw-leading-[30px] tw-tracking-title"
              >
                <p class="entry-field tw-m-0">Trenutni način plačevanja:</p>
                <p
                  class="entry-value tw-break-words tw-m-0 tw-font-bold tw-self-end"
                >
                  Univerzalni plačilni nalog
                </p>
              </div>

              <div
                class="recap-section__entry tw-flex tw-justify-between tw-mb-small tw-gap-[5px] tw-font-sans tw-text-normal tw-leading-[30px] tw-tracking-title"
              >
                <p class="entry-field tw-m-0">Nov način plačevanja:</p>
                <p
                  class="entry-value tw-break-words tw-m-0 tw-font-bold tw-self-end"
                >
                  {{ displayValues.paymentMethod }}
                </p>
              </div>

              <div
                class="recap-section__entry tw-flex tw-justify-between tw-mb-small tw-gap-[5px] tw-font-sans tw-text-normal tw-leading-[30px] tw-tracking-title"
              >
                <p class="entry-field tw-m-0">Transakcijski račun:</p>
                <p
                  class="entry-value tw-break-words tw-m-0 tw-font-bold tw-self-end"
                >
                  {{ inputTRR }}
                </p>
              </div>

              <div
                class="recap-section__entry tw-flex tw-justify-between tw-mb-0 tw-gap-[5px] tw-font-sans tw-text-normal tw-leading-[30px] tw-tracking-title"
              >
                <p class="entry-field tw-m-0">
                  Banka/Ponudnik plačilnih storitev:
                </p>
                <p
                  class="entry-value tw-break-words tw-m-0 tw-font-bold tw-self-end"
                >
                  {{ alternativeTRRBankName }}
                </p>
              </div>

              <div
                class="recap-section__entry tw-flex tw-justify-between tw-mb-0 tw-gap-[5px] tw-font-sans tw-text-normal tw-leading-[30px] tw-tracking-title"
              >
                <p class="entry-field tw-m-0">
                  Imetnik transakcijskega računa:
                </p>
                <p
                  class="entry-value tw-break-words tw-m-0 tw-font-bold tw-self-end"
                >
                  {{ alternativeTRROwner }}
                </p>
              </div>

              <div
                class="recap-section__entry tw-flex tw-justify-between tw-mb-0 tw-gap-[5px] tw-font-sans tw-text-normal tw-leading-[30px] tw-tracking-title"
              >
                <p class="entry-field tw-m-0">
                  Mobilna tel. št. za aktivacijo:
                </p>
                <p
                  class="entry-value tw-break-words tw-m-0 tw-font-bold tw-self-end"
                >
                  {{ clientContact.maskedValue }}
                </p>
              </div>
            </div>

            <ui-full-divider></ui-full-divider>

            <div class="personal-data-wrap">
              <div class="personal-data-desc">
                <p
                  class="tw-text-tzz-dark-gray tw-leading-[24px] tw-text-[15px]"
                >
                  <b>Pomembno:</b> Upravljavec osebnih podatkov je Triglav,
                  Zdravstvena zavarovalnica, d.d., Dunajska cesta 22, 1000
                  Ljubljana, ki vaše osebne podatke obdeluje za namen izvajanja
                  pogodb o zavarovanju, izterjave neplačanih obveznosti iz
                  naslova zavarovalnih pogodb ter uveljavljanja drugih pravic in
                  obveznosti zavarovalnice na podlagi točke (b) člena 6(1)
                  Splošne uredbe o varstvu podatkov v zvezi z 286. členom Zakona
                  o zavarovalništvu. V zvezi z obdelavo osebnih podatkov imate
                  pravico zahtevati dostop in seznanitev z lastnimi osebnimi
                  podatki, popravek osebnih podatkov, omejitev obdelave, prenos
                  in izbris osebnih podatkov oz. pravico ugovora zoper obdelavo
                  vaših osebnih podatkov. Vaše pravice lahko uveljavljate s
                  pisno zahtevo, poslano na naslov: Triglav, Zdravstvena
                  zavarovalnica, d.d., Dunajska cesta 22, 1000 Ljubljana -
                  Capodistria, ali dpo@triglavzdravje.si. Pooblaščeno osebo za
                  varstvo podatkov pri organizatorju dogodka lahko kontaktirate
                  preko elektronskega naslova: dpo@triglavzdravje.si. Kot
                  posameznik imate pravico vložiti pritožbo pri Informacijskem
                  pooblaščencu Republike Slovenije, če menite, da se vaši osebni
                  podatki obdelujejo v nasprotju z veljavnimi predpisi, ki
                  urejajo varstvo osebnih podatkov. Več informacij o varstvu
                  osebnih podatkov pri organizatorju dogodka si lahko preberete
                  v Politiki zasebnosti, objavljeni na spletni strani
                  <a href="https://www.triglavzdravje.si">triglavzdravje.si</a>.
                </p>
              </div>
            </div>

            <ui-checkbox
              v-if="selectedPaymentOption === 'L'"
              :value="agreement"
              name="agreement"
              :required="true"
              title="POTRJUJEM oddajo vloge za spremembo načina plačila premij na SEPA DIREKTNO OBREMENITEV za vse zavarovalne pogodbe, ki jih Triglav, Zdravstveni zavarovalnici, d.d. do tega trenutka plačujem z univerzalnim plačilnim nalogom."
              @change="agreement = $event"
              class="!tw-w-full"
            ></ui-checkbox>

            <ui-checkbox
              v-if="selectedPaymentOption === 'E'"
              :value="agreement"
              name="agreement"
              :required="true"
              title="POTRJUJEM oddajo vloge za spremembo načina plačila premij na E-RAČUN V SPLETNO BANKO za vse zavarovalne pogodbe, ki jih Triglav, Zdravstveni zavarovalnici, d.d. do tega trenutka plačujem z univerzalnim plačilnim nalogom."
              @change="agreement = $event"
              class="!tw-w-full"
            ></ui-checkbox>

            <ui-full-divider></ui-full-divider>

            <ui-button
              class="!tw-w-full !tw-m-0 !tw-mb-20 !tw-text-normal"
              label="NADALJUJ"
              :type="'primary'"
              :disabled="!agreement"
              @click="onSubmit()"
              fg-keydown-enter-click
            ></ui-button>

            <ui-button
              class="!tw-flex !tw-my-0 !tw-mx-auto !tw-mb-40 !tw-text-normal tw-w-full"
              label="NAZAJ"
              :type="'flat green'"
              @click="onStepChange('BACK')"
            ></ui-button>
          </div>
        </ui-formgroup>

        <!--        STEP 8 - HVALA  -->
        <ui-formgroup
          v-if="currentStep === 8"
          :key="8"
          class="tw-absolute tw-w-full"
        >
          <div class="content tw-mx-auto mini:tw-w-11/12 mob:tw-w-[343px]">
            <img
              src="./../../assets/icon-check.svg"
              alt="check"
              class="tw-block tw-mx-auto tw-my-big desktop:tw-mt-extra"
            />

            <h1
              class="soglasje-sdd-eracun__pregled-izbira-kontakta-title tw-mb-small+ tw-text-tzz-dark-gray tw-font-bold tw-text-title tw-leading-40 tw-text-center"
            >
              {{ clientFirstNameCapitalised }}, hvala.
            </h1>

            <h1
              class="soglasje-sdd-eracun__pregled-izbira-kontakta-title tw-mb-small+ tw-text-tzz-dark-gray tw-font-bold tw-text-[15px] tw-leading-[25px] tw-text-center"
            >
              Uspešno ste oddali vlogo za spremembo načina plačila.
            </h1>

            <h1
              class="soglasje-sdd-eracun__pregled-izbira-kontakta-title tw-mb-small+ tw-text-tzz-dark-gray tw-font-bold tw-text-[15px] tw-leading-[25px] tw-text-center"
            >
              <span
                >V kratkem boste prejeli SMS sporočilo za aktivacijo spremembe,
                na katerega odgovorite z
              </span>
              <br />
              <span
                class="soglasje-sdd-eracun__pregled-izbira-kontakta-title tw-mb-small+ tw-text-tzz-blue tw-font-bold tw-text-title tw-leading-40 tw-text-center"
                >DA</span
              >
            </h1>

            <h1
              class="soglasje-sdd-eracun__pregled-izbira-kontakta-title tw-mb-small+ tw-text-tzz-dark-gray tw-font-bold tw-text-[15px] tw-leading-[25px] tw-text-center"
            >
              Po potrditvi vas vabimo, da sodelujete v NAGRADNI IGRI in se
              potegujete za privlačne nagrade.
            </h1>
          </div>
        </ui-formgroup>
      </ui-form>
    </div>
  </div>
</template>

<script>
import POBRFormMixin from "@/mixins/POBR-Form.mixin";
import Validators_mixin from "@/mixins/validators.mixin";
import POBRMixin from "@/mixins/POBR.mixin";
import CommonMixin from "@/mixins/common.mixin";
import ClientMixin from "@/mixins/client.mixin";
import Header from "@/components/Header";
import UIForm from "@/components/ui/UIForm";
import UIFormGroup from "@/components/ui/UIFormGroup";
import UIInput from "@/components/ui/UIInput";
import UIDatepicker from "@/components/ui/UIDatepicker";
import StevilkaZdravstveneKarticeInfo from "@/components/ui/StevilkaZdravstveneKarticeInfo";
import UIButton from "@/components/ui/UIButton";
import UIButtonWithIcon from "@/components/ui/UIButtonWithIcon";
import UIMiniLoader from "@/components/ui/UIMiniLoader";
import UISelect from "@/components/ui/UISelect";
import UIDivider from "@/components/ui/UIDivider";
import UICodeInput from "@/components/ui/UICodeInput";
import UISelectableTRR from "@/components/ui/UISelectableTRR";
import UIFullDivider from "@/components/ui/UIFullDivider";
import UICheckbox from "@/components/ui/UICheckbox";
import { mapGetters } from "vuex";

export default {
  name: "soglasje-sdd-eracun",
  mixins: [
    CommonMixin,
    Validators_mixin,
    POBRFormMixin,
    POBRMixin,
    ClientMixin,
  ],

  props: {
    form: {
      type: Object,
      required: true,
    },
    client: {
      type: Object,
      required: true,
    },
    isAuthITriglav: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      currentStep: 0,
      stepsHistory: [],

      birthDateOpen: new Date(1996, 0, 1),
      displayValues: {},
      davcnaValidate: undefined,
      kzzValidate: undefined,
      emailValidate: undefined,
      phoneValidate: undefined,
      trrValidate: undefined,

      clientVATDisabled: false,
      clientKZZDisabled: false,
      clientBirthDateDisabled: false,

      selectedPaymentOption: undefined,
      clientIBANsAutofill: undefined,
      clientIBANsVerified: [],

      inputTRR: undefined,
      alternativeTRRFGValid: false,
      alternativeTRRAttemptedValidation: undefined,
      alternativeTRRBankName: undefined,
      alternativeTRRBankBIC: undefined,
      alternativeTRROwner: undefined,
      trrAgreement: false,

      isContactsLoading: false,
      clientContacts: undefined,
      phoneAutofillOptions: undefined,
      clientContact: undefined,
      alternativeClientContactValue: undefined,
      enterAlternativeClientContact: false,
      alternativeClientContactConfirmed: false,

      alternativeContactFGValid: false,
      alternativeContactOTPSent: false,
      otpCodeInput: undefined,
      clientContactToVerify: undefined,

      allowGSMContactOTPCheck: false,

      clientFirstNameCapitalised: undefined,
      agreement: false,
    };
  },

  mounted() {
    // Setup validators
    this.davcnaValidate = [this.VALIDATORS.VAT];
    this.kzzValidate = [this.VALIDATORS.KZZ];
    this.emailValidate = [this.VALIDATORS.EMAIL];
    this.phoneValidate = [this.VALIDATORS.PHONE];
    this.trrValidate = [this.VALIDATORS.TRR];

    // Disable pre-filled fields
    if (this.client.vat) {
      this.clientVATDisabled = true;
    }

    if (this.client.kzz) {
      this.clientKZZDisabled = true;
    }

    if (this.client.birthDate) {
      this.clientBirthDateDisabled = true;
    }

    this.onBirthDateChanged(this.client.birthDate);

    if (this.authData.soglasjeSDDEracun.requireInputClientData === false) {
      this.currentStep = 1;
    }

    this.setClientFirstNameCapitalised();

    document.addEventListener("keydown", (e) => {
      if (e.code === "Enter") {
        e.preventDefault();
      }
    });
  },

  methods: {
    setClientFirstNameCapitalised() {
      if (this.client.firstName && this.client.firstName.length > 0) {
        this.clientFirstNameCapitalised =
          this.client.firstName.charAt(0).toUpperCase() +
          this.client.firstName.substring(1).toLowerCase();
      } else {
        this.clientFirstNameCapitalised = undefined;
      }
    },
    onStepChange(toStep) {
      if (this.currentStep === toStep) return;

      if (toStep === "BACK") {
        if (
          this.currentStep === 0 ||
          (this.authData.soglasjeSDDEracun.requireInputClientData === false &&
            this.currentStep === 1)
        ) {
          return this.logout();
        } else if (this.currentStep === 3) {
          if (this.inputTRR) {
            const formattedIBAN = this.inputTRR
              .split(" ")
              .join("")
              .toUpperCase();
            this.inputTRR = undefined;

            this.clientIBANsVerified = this.clientIBANsVerified.filter(
              (i) => i.iban !== formattedIBAN,
            );

            this.alternativeTRRBankName = undefined;
            this.alternativeTRRBankBIC = undefined;
            this.alternativeTRROwner = undefined;
            this.trrAgreement = false;
          }
        } else if (this.currentStep === 4) {
          this.stepsHistory = [0, 1, 2];
        } else if (this.currentStep === 5) {
          this.enterAlternativeClientContact = false;

          if (
            Array.isArray(this.phoneAutofillOptions) &&
            this.phoneAutofillOptions.length > 0
          ) {
            this.onAutofillOptionSelected(
              this.phoneAutofillOptions[this.phoneAutofillOptions.length - 1],
            );
          }

          this.alternativeClientContactValue = undefined;
        } else if (this.currentStep === 7) {
          this.stepsHistory = [0, 1, 2, 4];
        }

        this.currentStep = this.stepsHistory.pop();
      } else {
        if (toStep === 1) {
          this.onIdentification(this.client).then(() => {
            this.stepsHistory.push(this.currentStep);
            this.currentStep = toStep;
          });
        } else {
          this.stepsHistory.push(this.currentStep);
          this.currentStep = toStep;
        }
      }

      if (this.authData.soglasjeSDDEracun.requireInputClientData === false) {
        this.stepsHistory = this.stepsHistory.filter((s) => s > 0);
      }
    },

    // step 0
    onBirthDateChanged(value) {
      if (value) {
        this.displayValues.birthDate = this.dateToString(value);
      }

      this.$forceUpdate();
    },

    // step 1
    async onPaymentMethodSelected(value) {
      this.selectedPaymentOption = value;

      if (value === "L") {
        this.displayValues.paymentMethod = "SEPA direktna obremenitev";
      } else {
        this.displayValues.paymentMethod = "E-račun v spletno banko";
      }

      try {
        this.showLoadingBig();
        const fetchIBANsResponse = await this.$http.get(
          "/pobr/soglasje-sdd-eracun/iban",
        );
        this.clientIBANsAutofill = fetchIBANsResponse.data;
      } catch {
        this.clientIBANsAutofill = [];
      } finally {
        this.hideLoading();
        this.onStepChange(2);
      }
    },

    // step 2
    onSelectedTRRToggle(trrInfo) {
      console.log(trrInfo);

      if (this.inputTRR === trrInfo.iban) {
        this.inputTRR = undefined;
        this.alternativeTRRBankName = undefined;
        this.alternativeTRRBankBIC = undefined;
        this.alternativeTRROwner = undefined;
      } else {
        this.inputTRR = trrInfo.iban;
        this.alternativeTRRBankName = trrInfo.bankName;
        this.alternativeTRRBankBIC = trrInfo.bankBIC;
        this.alternativeTRROwner = trrInfo.ownerFullName;
      }
    },
    onEnterAlternativeTRRClicked() {
      this.inputTRR = undefined;

      this.alternativeTRRBankName = undefined;
      this.alternativeTRRBankBIC = undefined;
      this.alternativeTRROwner = undefined;

      this.onStepChange(3);
    },
    onTRRSet() {
      this.onStepChange(4);
      this.isContactsLoading = true;

      this.fetchPOBRClientContacts().then((result) => {
        this.clientContacts = result;

        if (result.length > 0) {
          this.phoneAutofillOptions = result
            .filter((cc) => cc.type === 1)
            .map((cc) => {
              return {
                label: cc.maskedValue,
                value: cc,
              };
            });

          if (this.phoneAutofillOptions.length > 0) {
            this.onAutofillOptionSelected(
              this.phoneAutofillOptions[this.phoneAutofillOptions.length - 1],
            );
          }
        }

        this.isContactsLoading = false;
      });
    },

    // step 3
    async onTRRValidated(valid) {
      if (valid && this.alternativeTRRAttemptedValidation !== this.inputTRR) {
        this.showLoadingBig();

        this.alternativeTRRAttemptedValidation = this.inputTRR;

        const trrInfo = await this.checkTRRValid(this.inputTRR);

        this.alternativeTRRBankName = trrInfo.bank;
        this.alternativeTRRBankBIC = trrInfo.bic;
        this.alternativeTRROwner =
          this.client.firstName + " " + this.client.lastName;

        const formattedIBAN = this.inputTRR.split(" ").join("").toUpperCase();

        const isExisting =
          (this.clientIBANsAutofill || [])
            .map((i) => i.iban.split(" ").join("").toUpperCase())
            .find((i) => i === formattedIBAN) !== undefined ||
          this.clientIBANsVerified.find((iv) => iv.iban === formattedIBAN);

        if (!isExisting) {
          this.clientIBANsVerified.push({
            iban: formattedIBAN,
            ownerFullName: this.alternativeTRROwner,
            bankName: this.alternativeTRRBankName,
            bankBIC: this.alternativeTRRBankBIC,
          });
        }

        this.hideLoading();
      } else {
        this.alternativeTRRAttemptedValidation = undefined;
        this.alternativeTRRBankName = undefined;
        this.alternativeTRRBankBIC = undefined;
        this.alternativeTRROwner = undefined;
      }
    },

    // step 4
    onAutofillOptionSelected(option) {
      this.enterAlternativeClientContact = false;
      this.clientContact = option.value;
    },
    onEnterAlternativeClientContactClicked() {
      this.enterAlternativeClientContact = true;
      this.clientContact = undefined;

      this.alternativeContactOTPSent = false;
      this.alternativeClientContactConfirmed = false;

      this.onStepChange(5);
    },
    async onAttemptPOBRContactVerification() {
      if (this.clientContact.id) {
        this.showLoadingBig();
        const attemptVerification = await this.attemptPOBRContactVerification(
          this.clientContact.id,
        );

        if (attemptVerification) {
          this.onStepChange(7);
        }

        this.hideLoading();
      } else if (this.clientContact.eid) {
        this.onAddClientContact();
      }
    },

    // step 5
    onAlternativeClientContactFieldInput() {
      this.alternativeContactOTPSent = false;
      this.alternativeClientContactConfirmed = false;
      this.otpCodeInput = undefined;
    },
    async onAddClientContact(e) {
      console.log(e);
      this.showLoadingBig();
      let addClientContactResult;

      if (this.enterAlternativeClientContact) {
        addClientContactResult = await this.addClientContact(
          1,
          this.alternativeClientContactValue,
        );
      } else if (this.clientContact && this.clientContact.eid) {
        addClientContactResult = await this.addClientContact(
          this.clientContact.type,
          undefined,
          undefined,
          this.clientContact.eid,
        );
      } else if (this.clientContact && this.clientContact.id) {
        addClientContactResult = await this.addClientContact(
          this.clientContact.type,
          undefined,
          undefined,
          undefined,
          this.clientContact.id,
        );
      }

      if (addClientContactResult.status === 200) {
        this.alternativeClientContactConfirmed = true;
        this.clientContact = addClientContactResult.data;
        this.enterAlternativeClientContact = false;

        this.notifySuccessQuick("Kontakt uspešno potrjen.");
        this.onStepChange(7);
      } else if (addClientContactResult.status === 201) {
        this.alternativeContactOTPSent = true;
        this.clientContactToVerify = addClientContactResult.data.id;
        this.clientContact = addClientContactResult.data;
        console.log("dobim 201", this.clientContact);

        this.notifySuccess(
          "Na vašo telefonsko številko smo vam prek sporočila SMS poslali kodo za potrditev kontakta.",
        );
        this.onStepChange(6);
      }

      this.hideLoading();
    },

    // step 6
    async onCheckGSMContactOTP() {
      this.showLoadingBig();

      const attemptClientCodeVerification =
        await this.attemptClientContactVerification(
          this.clientContactToVerify,
          this.otpCodeInput,
        );

      if (attemptClientCodeVerification.successful) {
        this.alternativeClientContactConfirmed = true;
        this.clientContact = attemptClientCodeVerification.verifiedEntity;

        this.notifySuccess("Telefonska številka uspešno potrjena.");

        const autofillContacts = await this.fetchPOBRClientContacts();
        this.phoneAutofillOptions = autofillContacts
          .filter((ac) => ac.type === 1)
          .map((ac) => {
            return {
              label: ac.maskedValue,
              value: ac,
            };
          });

        this.clientContact = this.phoneAutofillOptions.find(
          (ao) => ao.value.id === this.clientContactToVerify,
        ).value;
        this.clientContactToVerify = undefined;

        this.onAttemptPOBRContactVerification();
      } else {
        if (attemptClientCodeVerification.remainingAttempts > 0) {
          this.notifyCustomError(
            "Vnesena koda ni pravilna. Preostalih poskusov: " +
              attemptClientCodeVerification.remainingAttempts,
          );
        } else {
          this.otpCodeInput = undefined;
          this.clientContactToVerify = undefined;
          this.alternativeContactOTPSent = false;
          this.notifyCustomError(
            "Vnesena koda ni pravilna. Zaradi preveč neuspešnih poskusov morate generirati novo kodo.",
          );
          this.$refs["contact-code-input"].clear();
        }
      }

      this.hideLoading();
    },

    // step 7
    async onSubmit() {
      this.showLoadingBig();

      try {
        await this.$http.post("/pobr/soglasje-sdd-eracun", {
          nacinPlacila: this.selectedPaymentOption,
          trr: this.inputTRR,
          bank: this.alternativeTRRBankName,
          bic: this.alternativeTRRBankBIC,
          ibanOwner: this.alternativeTRROwner,
          client: this.client,
        });

        window.localStorage.removeItem("pobr-auth");

        this.onStepChange(8);
        this.hideLoading();
      } catch (e) {
        return await this.handleError(e, this.onSubmit.bind(this));
      }
    },
  },
  computed: {
    ...mapGetters(["hideHeader", "authData", "queryObject"]),
    allowAttemptPOBRContactVerification() {
      return (
        this.clientContact &&
        this.phoneAutofillOptions &&
        this.phoneAutofillOptions
          .map((pao) => pao.value)
          .includes(this.clientContact)
      );
    },
    isClientIBANsAutofill() {
      return (
        Array.isArray(this.clientIBANsAutofill) &&
        this.clientIBANsAutofill.length > 0
      );
    },
    isClientPhoneOptionsAutofill() {
      return (
        Array.isArray(this.phoneAutofillOptions) &&
        this.phoneAutofillOptions.length > 0
      );
    },
  },

  components: {
    "ui-header": Header,
    "ui-form": UIForm,
    "ui-formgroup": UIFormGroup,
    "ui-input": UIInput,
    "ui-select": UISelect,
    "ui-button": UIButton,
    "ui-datepicker": UIDatepicker,
    "stevilka-zdravstvene-kartice-info": StevilkaZdravstveneKarticeInfo,
    "ui-button-with-icon": UIButtonWithIcon,
    "ui-mini-loader": UIMiniLoader,
    "ui-divider": UIDivider,
    "ui-code-input": UICodeInput,
    "ui-selectable-trr": UISelectableTRR,
    "ui-full-divider": UIFullDivider,
    "ui-checkbox": UICheckbox,
  },
};
</script>

<style scoped lang="scss">
.entry-value {
  word-break: break-word;
  letter-spacing: 0 !important;
  text-align: right;
}

.agreements-list {
  list-style-type: circle !important;
}

.personal-data-wrap {
  height: 250px;
  padding: 1rem 0.5rem 1rem 1rem;
  background-color: white;
  margin-bottom: 1rem;
  border-radius: 10px;

  overflow: hidden;

  .personal-data-desc {
    padding-right: 0.5rem;
    height: 100%;
    overflow-y: auto;
    margin: 0;
  }
}
</style>
